export default __webpack_public_path__ + "static/media/logo_GeoMontfort.a0906892.png";